import { render, staticRenderFns } from "./formgrouptextarea.vue?vue&type=template&id=a6dcf9ba&"
import script from "./formgrouptextarea.vue?vue&type=script&lang=js&"
export * from "./formgrouptextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports